var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default",null,{"opened":_vm.opened,"title":_vm.title,"text":_vm.text,"okLabel":_vm.okLabel,"close":_vm.close})],2)}
var staticRenderFns = []

export { render, staticRenderFns }